module.exports = __webpack_public_path__ + "assets/img/hzhb6.7b5811ff.png";